import { connect } from 'react-redux';
import fanBoxMessagesAction from '../../../actions/fanboxMessages';
import FanBoxMessageEdit from './FanBoxMessageEdit';

export default connect(
  ({ fanBoxMessages: { loadingItem } }) => ({
    loading: loadingItem
  }),
  dispatch => ({
    fetch: (id) => dispatch(fanBoxMessagesAction.fetch(id))
  })
)(FanBoxMessageEdit)



// WEBPACK FOOTER //
// ./src/components/FanBox/FanBoxMessageEdit/index.js